import { getDownloadURL, listAll, ref } from "firebase/storage";
import { storage } from ".";

export const fetchImagUrls = async (path) => {
  try {
    const imagesRef = ref(storage, path);
    const result = await listAll(imagesRef);
    const urls = await Promise.all(
      result.items.map((item) => getDownloadURL(item))
    );
    console.log("urls", urls);
    return urls;
  } catch (e) {
    console.log("Error fetching images", e);
    return [];
  }
};
